export default "__VITE_ASSET__DPi$bIe8__"